// Умолчания разные намеренно. У iiko «выключено», чтобы блоки не мигали на нересторанном
// тенанте; у расшифровок «показывать», потому что при обратном умолчании текст диалога исчезал
// бы на каждой загрузке страницы до ответа /settings/features — и у всех, а не у меньшинства.
// Биометрия — платная опция, по умолчанию выключена, как iiko. Asterisk по умолчанию «нет»:
// тумблер внутренних звонков не должен мелькать на установках других телефоний.
export const DEFAULT_FEATURES = Object.freeze({
  iikoEnabled: false,
  transcriptsVisible: true,
  biometryEnabled: false,
  asteriskEnabled: false,
  internalCallsAnalyzed: true,
  usageAnalyticsEnabled: false
});

/**
 * Ответ /settings/features → флаги интерфейса. Отсутствующее поле трактуется так, чтобы фронтенд
 * новее бэкенда ничего не гасил молча: расшифровки показываются, внутренние звонки анализируются.
 */
export const normalizeFeatures = (result) => ({
  iikoEnabled: Boolean(result?.iikoEnabled),
  transcriptsVisible: result?.transcriptsVisible !== false,
  biometryEnabled: Boolean(result?.biometryEnabled),
  asteriskEnabled: Boolean(result?.asteriskEnabled),
  internalCallsAnalyzed: result?.internalCallsAnalyzed !== false,
  usageAnalyticsEnabled: Boolean(result?.usageAnalyticsEnabled)
});
